"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUIContextProviderProps = exports.useUIContext = exports.UIContextProvider = exports.UIContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Form_1 = require("../form/Form");
var Alert_1 = require("./alert/Alert");
var ErrorAlert_1 = require("./alert/ErrorAlert");
var WarningAlert_1 = require("./alert/WarningAlert");
var Confirmation_1 = require("./confirmation/Confirmation");
var Body_1 = require("./layout/body/Body");
var Footer_1 = require("./layout/footer/Footer");
var Header_1 = require("./layout/header/Header");
var Layout_1 = require("./layout/Layout");
var Loader_1 = require("./loader/Loader");
var useLoader_1 = require("./loader/useLoader");
var Modal_1 = require("./modal/Modal");
var ModalForm_1 = require("./modal/ModalForm");
var ErrorNotification_1 = require("./notification/ErrorNotification");
var Notification_1 = require("./notification/Notification");
var SuccessNotification_1 = require("./notification/SuccessNotification");
exports.UIContext = react_1.createContext({
    useLoader: useLoader_1.useLoader,
    useSuccessNotification: SuccessNotification_1.useSuccessNotification,
    useErrorNotification: ErrorNotification_1.useErrorNotification,
    useErrorAlert: ErrorAlert_1.useErrorAlert,
    useWarningAlert: WarningAlert_1.useWarningAlert,
    useConfirmation: Confirmation_1.useConfirmation,
    useLayout: Layout_1.useLayout,
    useForm: Form_1.useForm,
    useModal: Modal_1.useModal,
    useModalForm: ModalForm_1.useModalForm,
});
function UIContextProvider(props) {
    return (react_1.default.createElement(exports.UIContext.Provider, { value: tslib_1.__assign(tslib_1.__assign({}, useUIContextProviderProps()), props), children: props === null || props === void 0 ? void 0 : props.children }));
}
exports.UIContextProvider = UIContextProvider;
function useUIContext() {
    return react_1.useContext(exports.UIContext);
}
exports.useUIContext = useUIContext;
function useUIContextProviderProps() {
    return {
        useLoader: function (props) { return useLoader_1.useLoader(tslib_1.__assign({ Component: Loader_1.Loader }, props)); },
        useSuccessNotification: function (props) {
            return SuccessNotification_1.useSuccessNotification(tslib_1.__assign({ Component: Notification_1.Notification }, props));
        },
        useErrorNotification: function (props) { return ErrorNotification_1.useErrorNotification(tslib_1.__assign({ Component: Loader_1.Loader }, props)); },
        useErrorAlert: function (props) { return ErrorAlert_1.useErrorAlert(tslib_1.__assign({ Component: ErrorAlert_1.ErrorAlert }, props)); },
        useWarningAlert: function (props) { return WarningAlert_1.useWarningAlert(tslib_1.__assign({ Component: Alert_1.Alert }, props)); },
        useConfirmation: function (props) { return Confirmation_1.useConfirmation(tslib_1.__assign({ Component: Confirmation_1.Confirmation }, props)); },
        useLayout: function (props) {
            return Layout_1.useLayout(tslib_1.__assign(tslib_1.__assign({}, props), { HeaderComponent: Header_1.Header, BodyComponent: Body_1.Body, FooterComponent: Footer_1.Footer }));
        },
        useForm: function (props) { return Form_1.useForm(tslib_1.__assign({ Component: Form_1.Form }, props)); },
        useModal: function (props) { return Modal_1.useModal(tslib_1.__assign({ Component: Modal_1.Modal }, props)); },
        useModalForm: ModalForm_1.useModalForm,
    };
}
exports.useUIContextProviderProps = useUIContextProviderProps;
//# sourceMappingURL=UI.js.map